/* Store Ec · CAJÓN LATERAL DEL CARRITO + reloj «tu pedido está reservado».
   · window.X13C.abrir() / cerrar() / pintar(cart).
   · El ícono del carrito (#cart-icon-bubble) abre el cajón en vez de ir a /cart (en /cart sigue siendo un enlace).
   · X13T.agregar (x13-tienda.js) llama a X13C.abrir(cart) después de agregar: nunca va al pago.
   · Botones por línea: nacionales → data-x13-pedir="nacional" (x13-lineas.js abre EasySell);
     importados → enlace a /checkout (pasa por la guardia x13-guardia.js); mezclado → aviso + 2 botones. */
(function(){
  'use strict';
  if (window.X13C) return;
  var C = window.X13C = {};

  /* ---------- reloj de 10 minutos (sessionStorage; al llegar a 0 vuelve a empezar) ---------- */
  var CLAVE = 'x13_reserva_fin', DURA = 10 * 60 * 1000, finMem = 0;
  function fin(){
    var f = finMem;
    try { f = Number(sessionStorage.getItem(CLAVE)) || 0; } catch (e) {}
    if (!f || f - Date.now() <= 0 || f - Date.now() > DURA) {
      f = Date.now() + DURA - 1000; finMem = f;
      try { sessionStorage.setItem(CLAVE, String(f)); } catch (e) {}
    }
    return f;
  }
  function dos(n){ return (n < 10 ? '0' : '') + n; }
  function tic(){
    var els = document.querySelectorAll('[data-x13-reserva]'); if (!els.length) return;
    var s = Math.max(0, Math.ceil((fin() - Date.now()) / 1000)), txt = dos(Math.floor(s / 60)) + ':' + dos(s % 60);
    for (var i = 0; i < els.length; i++) if (els[i].textContent !== txt) els[i].textContent = txt;
  }
  C.tic = tic;
  setInterval(tic, 1000);

  /* ---------- utilidades ---------- */
  var NAC = function(){ return window.X13_NACIONAL || []; };
  function esNac(it){ return NAC().indexOf(it.product_id) > -1; }
  function dinero(c){ return 'US$' + (Number(c || 0) / 100).toFixed(2); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(m){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[m]; }); }
  function json(url, opt){ return fetch(url, opt).then(function(r){ return r.json(); }); }
  function carrito(){ return json('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }); }
  function img(u){ if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
  function enCarrito(){ return /^\/cart\/?$/.test(location.pathname); }

  var raiz, panel, lista, ultimoFoco = null;
  function el(sel){ return raiz.querySelector(sel); }

  function burbuja(){
    fetch(location.pathname + '?sections=cart-icon-bubble', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }).then(function(d){
      var b = document.getElementById('cart-icon-bubble'), h = d && d['cart-icon-bubble']; if (!b || !h) return;
      var s = new DOMParser().parseFromString(h, 'text/html').querySelector('.shopify-section'); if (s) b.innerHTML = s.innerHTML;
    }).catch(function(){});
  }

  /* ---------- dibujo ---------- */
  C.pintar = function(cart){
    if (!raiz) return;
    var items = cart.items || [], nac = items.filter(esNac), imp = items.filter(function(i){ return !esNac(i); });
    var n = cart.item_count || 0;
    el('[data-x13cj-n]').textContent = n ? '(' + n + (n === 1 ? ' producto)' : ' productos)') : '';
    el('[data-x13cj-vacio]').hidden = items.length > 0;
    el('[data-x13cj-pie]').hidden = !items.length;
    el('[data-x13cj-conf]').hidden = !items.length;
    var rr = el('[data-x13-reserva-caja]'); if (rr) rr.hidden = !items.length;

    lista.innerHTML = items.map(function(it){
      var opc = (it.options_with_values || []).filter(function(o){ return o.value && o.value !== 'Default Title'; }).map(function(o){ return o.value; });
      if (it.properties && it.properties.Color) opc.push('Color: ' + it.properties.Color);
      var desc = it.original_line_price > it.final_line_price;
      var titDesc = (it.line_level_discount_allocations || []).map(function(a){ return a.discount_application && a.discount_application.title; }).filter(Boolean)[0] || '';
      var nacional = esNac(it);
      return '<li class="x13cj__item" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true"><img class="x13cj__img" src="' + esc(img(it.image)) + '" alt="" width="72" height="72" loading="lazy"></a>' +
        '<div>' +
          '<a class="x13cj__nom" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (opc.length ? '<p class="x13cj__var">' + esc(opc.join(' · ')) + '</p>' : '') +
          '<span class="x13cj__linea ' + (nacional ? 'x13cj__linea--nac">Pagas al recibir' : 'x13cj__linea--imp">Pago con tarjeta') + '</span>' +
          '<div class="x13cj__abajo">' +
            '<div class="x13cj__cant" role="group" aria-label="Cantidad de ' + esc(it.product_title) + '">' +
              '<button type="button" data-x13cj-menos aria-label="Quitar una unidad"' + (it.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
              '<output aria-live="polite">' + it.quantity + '</output>' +
              '<button type="button" data-x13cj-mas aria-label="Agregar una unidad">+</button>' +
            '</div>' +
            '<div class="x13cj__precio">' + (desc ? '<s>' + dinero(it.original_line_price) + '</s>' : '') + '<b>' + dinero(it.final_line_price) + '</b>' +
              (desc ? '<span class="x13cj__ahorro">' + (titDesc ? esc(titDesc) + ': ' : 'Ahorras ') + '−' + dinero(it.original_line_price - it.final_line_price) + '</span>' : '') + '</div>' +
          '</div>' +
          '<button type="button" class="x13cj__quitar" data-x13cj-quitar>Quitar</button>' +
        '</div></li>';
    }).join('');

    /* totales: /cart.js ya trae los descuentos automáticos aplicados */
    var ahorro = (cart.original_total_price || 0) - (cart.total_price || 0);
    el('[data-x13cj-sub-fila]').hidden = ahorro <= 0;
    el('[data-x13cj-sub]').textContent = dinero(cart.original_total_price);
    el('[data-x13cj-desc-fila]').hidden = ahorro <= 0;
    el('[data-x13cj-desc]').textContent = '−' + dinero(ahorro);
    var titulos = [];
    (cart.cart_level_discount_applications || []).forEach(function(d){ if (d.title) titulos.push(d.title); });
    items.forEach(function(it){ (it.line_level_discount_allocations || []).forEach(function(a){ var t = a.discount_application && a.discount_application.title; if (t && titulos.indexOf(t) < 0) titulos.push(t); }); });
    el('[data-x13cj-desc-t]').textContent = 'Descuento';
    el('[data-x13cj-total]').textContent = dinero(cart.total_price);

    /* botones según la línea */
    var ctas = el('[data-x13cj-ctas]'), nacUrl = nac.length ? String(nac[0].url || '/collections/nacional').split('?')[0] : '';
    ctas.setAttribute('data-x13-linea-pago', ''); ctas.setAttribute('data-nac-url', nacUrl);
    var h = '';
    if (nac.length && imp.length) {
      h = '<p class="x13cj__nota"><strong>Dos tipos de envío:</strong> los nacionales se pagan al recibir y los importados, con tarjeta. Pide primero unos; los otros quedan guardados.</p>' +
          '<button type="button" class="x13cj__btn x13cj__btn--nac" data-x13-pedir="nacional">Pedir los nacionales · pagas al recibir</button>' +
          '<button type="button" class="x13cj__btn x13cj__btn--imp" data-x13-pedir="importados">Pagar los importados con tarjeta</button>';
    } else if (nac.length) {
      h = '<button type="button" class="x13cj__btn x13cj__btn--nac" data-x13-pedir="nacional">Pedir ahora · pagas al recibir</button>';
    } else if (imp.length) {
      h = '<a class="x13cj__btn x13cj__btn--pagar" href="/checkout">Pagar</a>';
    }
    if (items.length) h += '<a class="x13cj__ver" href="/cart">Ver el carrito completo</a>';
    ctas.innerHTML = h;

    /* confianza: tarjetas solo si hay importados; «pagas en efectivo» solo si hay nacionales */
    var t = el('[data-x13cp-tarjetas]'), e = el('[data-x13cp-efectivo]');
    if (t) t.hidden = !imp.length; if (e) e.hidden = !nac.length;
    tic();
  };

  /* ---------- abrir / cerrar ---------- */
  function enfocables(){ return Array.prototype.filter.call(panel.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'), function(x){ return x.offsetParent !== null; }); }
  C.abrir = function(cart){
    if (!raiz) return false;
    if (!raiz.hidden && raiz.classList.contains('is-abierto')) { if (cart) C.pintar(cart); else carrito().then(C.pintar); return true; }
    ultimoFoco = document.activeElement;
    if (raiz.parentNode !== document.body || raiz.nextElementSibling) document.body.appendChild(raiz); /* encima de las ventanas de las apps */
    raiz.hidden = false; document.documentElement.classList.add('x13cj-bloqueo');
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ raiz.classList.add('is-abierto'); }); });
    if (cart) C.pintar(cart);
    carrito().then(C.pintar).catch(function(){});
    setTimeout(function(){ var x = raiz.querySelector('.x13cj__x'); if (x) x.focus({ preventScroll: true }); }, 60);
    return true;
  };
  C.cerrar = function(){
    if (!raiz || raiz.hidden) return;
    raiz.classList.remove('is-abierto'); document.documentElement.classList.remove('x13cj-bloqueo');
    var listo = function(){ if (!raiz.classList.contains('is-abierto')) raiz.hidden = true; };
    var reducido = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(listo, reducido ? 0 : 340);
    if (ultimoFoco && ultimoFoco.focus) try { ultimoFoco.focus({ preventScroll: true }); } catch (e) {}
  };

  /* ---------- cambiar cantidades ---------- */
  function cambiar(li, cant){
    var key = li.getAttribute('data-key'); li.setAttribute('aria-busy', 'true');
    var aviso = el('[data-x13cj-aviso]'); aviso.hidden = true;
    json('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: cant }) })
      .then(function(c){
        if (c && c.status && c.description) throw new Error(c.description);
        var antes = null; (c.items || []).forEach(function(i){ if (i.key === key) antes = i; });
        if (antes && antes.quantity < cant) { aviso.textContent = 'No hay más unidades disponibles de ese producto.'; aviso.hidden = false; }
        C.pintar(c); burbuja();
        document.dispatchEvent(new CustomEvent('x13t:carrito', { detail: c }));
      })
      .catch(function(e){ li.removeAttribute('aria-busy'); aviso.textContent = (e && e.message) || 'No se pudo actualizar. Intenta de nuevo.'; aviso.hidden = false; });
  }

  function iniciar(){
    raiz = document.getElementById('x13-cajon'); if (!raiz) return;
    panel = raiz.querySelector('.x13cj__panel'); lista = raiz.querySelector('[data-x13cj-lista]');
    raiz.addEventListener('click', function(e){
      if (e.target.closest('[data-x13cj-cerrar]')) { C.cerrar(); return; }
      var li = e.target.closest('.x13cj__item'); if (!li) return;
      var q = Number(li.querySelector('output').textContent) || 1;
      if (e.target.closest('[data-x13cj-mas]')) cambiar(li, q + 1);
      else if (e.target.closest('[data-x13cj-menos]')) cambiar(li, Math.max(1, q - 1));
      else if (e.target.closest('[data-x13cj-quitar]')) cambiar(li, 0);
    });
    document.addEventListener('keydown', function(e){
      if (raiz.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); C.cerrar(); return; }
      if (e.key === 'Tab') {
        var f = enfocables(); if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
    /* el ícono del carrito abre el cajón (fase de captura: antes que el tema o cualquier app) */
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('#cart-icon-bubble'); if (!a || enCarrito()) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault(); e.stopImmediatePropagation();
      C.abrir();
    }, true);
    window.addEventListener('pageshow', function(e){ if (e.persisted) C.cerrar(); });
    tic();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
